export default __webpack_public_path__ + "static/media/pakistan.0610bd75.jpg";